// extracted by css-extract-rspack-plugin
export default {"Text":"SwitchToGlobalResults_Text__MvFHv","EmphasisText":"SwitchToGlobalResults_EmphasisText__lD7Wq","SwitchToBtn":"SwitchToGlobalResults_SwitchToBtn__vc2gu"};